import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Card, CardContent, Heading, Grid, GridColumn, Icon, Button, Separator, AnalyticsTrigger, CardBottom, CardTop } from 'telia-front-react';
export const ExceptionCard = (props) => {
    const { offer } = props;
    const { translate } = React.useContext(TranslationsContext);
    return (React.createElement(Card, { background: "neutral-bg-level-1", type: "employee" },
        React.createElement(CardContent, { tagTop: {
                text: translate('internetCalculator.consultantException'),
                purpose: 'employee',
            } },
            React.createElement(CardTop, null,
                React.createElement(Heading, { element: "h2" }, translate('internetCalculator.exceptionCard.title')),
                React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
                React.createElement(Grid, { horizontalGutter: "small", noWrap: true },
                    React.createElement(GridColumn, { width: ['min'] },
                        React.createElement(Icon, { modifiers: "#fiber", size: "xs" })),
                    React.createElement(GridColumn, { width: ['max'] },
                        React.createElement("p", null, translate('internetCalculator.exceptionCard.description'))))),
            React.createElement(CardBottom, null,
                React.createElement(AnalyticsTrigger, { trigger: {
                        id: `CTA - ${offer.productOfferingCode}`,
                        callback: 'onClick',
                    } },
                    React.createElement(Button, { type: "employee", text: translate('internetCalculator.exceptionCard.order'), block: true, url: offer.orderingUrl, iconRight: "#arrow-right" }))))));
};
